import { InternalDimensionActionTypes } from './types';

export const storeInternalDimension = (data: any) => ({
  type: InternalDimensionActionTypes.STORE_DATA,
  payload: {
    data,
  },
});
